import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const milkListSelector = createSelector(
  (state: RootState) => state.milk.milkList,
  (milkList) => milkList,
);

export const isEnableLoadingSelector = createSelector(
  (state: RootState) => state.milk,
  (item) => item.nextToken !== '',
);

export const isInitMilkSelector = createSelector(
  (state: RootState) => state.milk,
  (item) => item.nextToken !== null,
);
